import styled from "styled-components";

export const GameOverContainer = styled.div`
  height: 100%;
  width: 100%;
  text-align: center;
  display: grid;
  align-content: center;
  row-gap: 7px;
`;

export const GameInfo = styled.div`
  margin-bottom: 5px;
`;
